/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Center, Container, Flex, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { faList, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import c from '../../../constant';
import BreadcrumbComponent from '../../../components/BreadcrumbComponent/BreadcrumbComponent';
import PrintLayout from '../../../components/Print/PrintLayout';
import composeQueries from '../../../utils/composeQueries';
import Filter from '../../../components/MarketDevelopment/Miscellaneous/filter-dashboard';
import { getReportTitle } from '../Utils';
import ClaimByProductGraph from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimByProductGraph';
import ClaimDeniedVsClaimIncurredGraph from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimDeniedVsClaimIncurredGraph';
import {
	default as ClaimDeniedGrossPremiumGrowthGraph,
	default as ClaimIncurredGrossPremiumGrowthGraph,
	default as ClaimOutstandingGrossPremiumGrowthGraph,
	default as ClaimPaidGrossPremiumGrowthGraph,
} from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimGrowthGraph';
import {
	default as ClaimDeniedNumPoliciesGrossPremium,
	default as ClaimIncurredNumPoliciesGrossPremium,
	default as ClaimOutstandingNumPoliciesGrossPremium,
	default as ClaimPaidNumPoliciesGrossPremium,
} from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimNumPoliciesGrossPremium';
import ClaimPaidVsClaimDeniedGraph from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimPaidVsClaimDeniedGraph';
import ClaimPaidVsClaimIncurredGraph from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimPaidVsClaimIncurredGraph';
import ClaimSidebar from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClaimSidebar';
import ClamAverageAmountPerPolicyGraph from '../../../components/MarketDevelopment/MonthlyClaim/Dashboard/ClamAverageAmountPerPolicyGraph';
import useCompanyReportStore from '../../../store/company-report-persistent-store';
import { dateRangeStringToDateRange, dateRangeToQueryString } from '../../../utils';

export default function MonthlyClaimGraph() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const period = urlParams.get('period') || null;
	const reportId = urlParams.get('reportId') || null;
	const companyType = urlParams.get('companyType') || null;
	const companyId = urlParams.get('companyId') || null;
	const rangeOption = urlParams.get('rangeOption') || null;
	const rangeValue = urlParams.get('rangeValue') || null;
	const { push } = useHistory();
	const { t } = useTranslation();
	const { setCompanyType, setCompanyId } = useCompanyReportStore();

	function onApplyingFilter({ companyType = null, companyId = null, rangeOption = null, rangeValue = null }) {
		let url = '/market-development-data/monthly-claim-graph?period=' + period + '&reportId=' + reportId;

		if (companyType) {
			url = url + '&companyType=' + companyType;
		}

		if (companyId) {
			url = url + '&companyId=' + companyId;
		}

		if (rangeOption) {
			url = url + '&rangeOption=' + rangeOption;
		}

		if (rangeValue?.from && rangeValue?.to) {
			url = url + '&rangeValue=' + dateRangeToQueryString(rangeValue);
		}

		setCompanyType(companyType);

		setCompanyId(companyId);

		push(url);
	}

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'Insurance Institute Report',
								path: '/company-submission-report',
							},
							{
								name: period,
								path: '/company-submission-report?period=' + period,
							},
							{
								name: getReportTitle(reportId),
								path: composeQueries('/market-development-data?period=' + period + '&reportId=' + reportId, { companyType, companyId }),
							},
							{
								name: 'Graph',
								path: '#',
							},
						]}
					/>
					<Center className="show-only-printing">
						<Text textAlign="center" color="#62B3ED" fontFamily="Moul" fontSize={18}>
							{t('Receiving and Settling Claim Report for Insurance Company')}
						</Text>
					</Center>
					<Center mt="5">
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb="32px"
						>
							<Flex
								className="hidden-print responsive-header-for-table"
								bg="#FAFAFA"
								p="16px"
								pt="8px"
								pb="8px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<Text fontSize="x-large" fontWeight="bold">
									{t('Receiving and Settling Claim Report for Insurance Company')}
								</Text>
								<Flex>
									<Stack direction={['column', 'column', 'row']} justifyContent="flex-end" alignItems="center" className="hidden-print">
										<Button
											className="hidden-print"
											isLoading={false}
											isDisabled={false}
											leftIcon={<FontAwesomeIcon icon={faList} style={{ fontSize: 16 }} />}
											size="sm"
											borderRadius={c.borderRadius}
											border="1px solid #bdc3c7"
											colorScheme="gray"
											variant="solid"
											onMouseDown={() => {
												let params = '?period=' + period + '&reportId=' + reportId;
												push('/market-development-data' + composeQueries(params, { companyType, companyId }));
											}}
										>
											{t('List')}
										</Button>
										<Button
											className="hidden-print"
											isLoading={false}
											isDisabled={false}
											onClick={() => window?.print()}
											leftIcon={<FontAwesomeIcon icon={faPrint} style={{ fontSize: 16 }} />}
											size="sm"
											borderRadius={c.borderRadius}
											border="1px solid #bdc3c7"
											colorScheme="gray"
											variant="solid"
										>
											{t('Print')}
										</Button>
										<Filter
											companyType={companyType}
											companyId={companyId}
											rangeOption={rangeOption}
											rangeValue={dateRangeStringToDateRange(rangeValue)}
											onCallback={onApplyingFilter}
										/>
									</Stack>
								</Flex>
							</Flex>
							<Box p="16px" pt="0">
								<Box display={['', '', 'flex']}>
									<Box width="100%" height="auto" mt={[4, 4, 0]}>
										<VStack spacing={4}>
											<ClaimSidebar companyType={companyType} companyId={companyId} range={dateRangeStringToDateRange(rangeValue)} />
											<SimpleGrid w="100%" columns={{ base: 2, sm: 1, md: 2 }} spacing={4}>
												<ClaimByProductGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClamAverageAmountPerPolicyGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimPaidNumPoliciesGrossPremium
													title="Claim Paid"
													claimType="ClaimPaid"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimPaidGrossPremiumGrowthGraph
													title="Growth of Claim Paid"
													claimType="ClaimPaid"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimDeniedNumPoliciesGrossPremium
													title="Claim Denied"
													claimType="ClaimDenied"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimDeniedGrossPremiumGrowthGraph
													title="Growth of Claim Denied"
													claimType="ClaimDenied"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimOutstandingNumPoliciesGrossPremium
													title="Outstanding Claims"
													claimType="OutstandingClaim"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimOutstandingGrossPremiumGrowthGraph
													title="Growth of Outstanding Claims"
													claimType="OutstandingClaim"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimIncurredNumPoliciesGrossPremium
													title="Claim Incurred"
													claimType="ClaimIncurred"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimIncurredGrossPremiumGrowthGraph
													title="Growth of Claim Incurred"
													claimType="ClaimIncurred"
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimPaidVsClaimIncurredGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimDeniedVsClaimIncurredGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
												<ClaimPaidVsClaimDeniedGraph
													companyType={companyType}
													companyId={companyId}
													range={dateRangeStringToDateRange(rangeValue)}
												/>
											</SimpleGrid>
										</VStack>
									</Box>
								</Box>
							</Box>
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}
